import { gql } from '@apollo/client'

export type { CreateField, CreateFieldVariables } from './types/index.graphql'

export const CREATE_FIELD = gql`
  mutation CreateField($createFieldDTO: CreateFieldInput!) {
    createField(createFieldDTO: $createFieldDTO) {
      field {
        id
        name
        productionType
        deliveryCondition
      }
    }
  }
`
